
import { DatabaseService } from './../../services/database/database.service';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Route, Router } from '@angular/router';
import { CodeGenerationRequest, Database, DatabaseName, S3BucketResponse, SnowDatabases, SnowSchema, ToastMessage } from '../../../models/database';
import { HttpClient } from '@angular/common/http';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataShareService } from '../../services/data_share/data-share.service';
import { finalize, Subject, Subscription, takeUntil } from 'rxjs';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../services/toast/toast.service';
import { LoadingServiceService } from '../../services/loadingService/loading-service.service';

@Component({
  selector: 'app-outputstorage-page',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbToastModule],
  templateUrl: './outputstorage-page.component.html',
  styleUrl: './outputstorage-page.component.scss'
})
export class OutputstoragePageComponent implements OnInit, OnDestroy {

  @ViewChild('rowsInput') rowsInput!: ElementRef;

  databaseName: Database[] = [];
  numberOfRows: number | null = null;
  selectedBucket: string | null = null
  selectedDatabase: string = ''
  inputDatabaseName: string | null = null
  postResponse: any;
  // toasts: ToastMessage[] = [];

  platforms: string[] = ['snowflake', 'other'];
  selectedPlatform: string = this.platforms[0];
  selectedPlatformType: string | null = null
  databases: string[] = [];
  schemas: string[] = [];
  selectedSchema: string = '';
  filePath: string = '';
  fileName: string = '';
  ful_dd: boolean = false;
  mat_box: boolean = false;
  dmshSystemName: string = '';
  isLoadingBuckets: boolean = false;
  isLoadingSchemas: boolean = false;
  isLoadingDatabases: boolean = false;

  private destroy$ = new Subject<void>();
  private responseSubscription: Subscription | undefined


  constructor(
    private router: Router,
    private router1: ActivatedRoute,
    private http: HttpClient,
    private databaseService: DatabaseService,
    private dataSharing: DataShareService,
    public toastService: ToastService,
    public loadService: LoadingServiceService,
    private cdRef: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.loadService.show()
      this.loadData();

      this.dataSharing.selectedDatabase$.subscribe(database => {
        this.inputDatabaseName = database
        if (this.inputDatabaseName) {
          this.toastService.showToast("Stage 2 Successfully completed", { classname: 'bg-success text-light' })
        } else {
          console.log('Error Occured');
        }
      })

      this.responseSubscription = this.databaseService.postResponse$.subscribe({
        next: (response) => {
          this.postResponse = response;
          if (response && response.filepath) {
            this.filePath = response.filepath
            const parts = this.filePath.split('/')
            this.fileName = parts[parts.length - 1]
            // this.showToast("Data Stored Successfully", {classname: 'bg-success text-light'})
            // console.log("Received post response", response)
            // console.log("Filename is : ", this.fileName)
          } else {
            // console.warn("Response doesn't contain file_path : ", response)
            this.toastService.showToast("The Payload isn't created properly", { classname: 'bg-warning text-light' })
          }
        }, error: (error) => {
          console.log("Error getting previous response", error)
        }
      });

      // this.onPlatformChange({ target: { value: this.selectedPlatform } });
    }
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()

    if (this.responseSubscription) {
      this.responseSubscription.unsubscribe();
    }
  }

  // Add this validation method to the component
  isDmshValid(): boolean {
    return !this.mat_box || (this.mat_box && this.dmshSystemName.trim() !== '');
  }

  loadData() {
    this.listDatabases()
  }

  listDatabases(): void {
    //const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseService.getDatabases().pipe(
      finalize(() => this.loadService.hide())
    ).subscribe((data) => {
      this.databaseName = data;
      this.selectedDatabase = ''
      this.isLoadingDatabases = true;
      this.cdRef.detectChanges();
    },
      (error) => {
        console.log("Error getting database list", error)
      });
  }

  onPlatformChange(event: any) {
    const selectedPlatform = (event.target as HTMLSelectElement).value;
    this.selectedPlatform = selectedPlatform;
    this.databases = [];
    this.schemas = [];
    this.selectedDatabase = '';
    this.selectedSchema = '';

    const selectedDB = this.databaseName.find(db => db.platform_name === selectedPlatform)

    if (selectedDB) {
      this.selectedPlatformType = selectedDB.platform_type
      if (this.selectedPlatformType === 'snowflake') {
        this.loadSnowflakeDatabases(selectedDB.platform_name);
      }
    }

  }

  loadSnowflakeDatabases(selectedDB: any) {
    this.isLoadingDatabases = true;
    //const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseService.snowDatabases(selectedDB).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response: SnowDatabases) => {
        this.databases = response.databases;
        this.isLoadingDatabases = false;
        if (this.databases.length > 0) {
          this.selectedDatabase = this.databases[0];
          this.onDatabaseChange({ target: { value: this.selectedDatabase } });
        }
      },
      error: (error) => {
        console.log("Error loading Snowflake databases:", error);
        this.isLoadingDatabases = false;
        this.toastService.showToast("Error loading Snowflake databases.", { classname: 'bg-danger text-light' });
      }
    });
  }

  onDatabaseChange(event: any) {
    // const selectedPlatform = (event.target as HTMLSelectElement).value;
    // this.selectedPlatform = selectedPlatform
    this.selectedDatabase = (event.target as HTMLSelectElement).value;
    this.schemas = [];
    this.selectedSchema = '';

    // const selectedDB = this.databaseName.find(db => db.platform_name === selectedPlatform)
    // if (selectedDB){
    //   this.selectedPlatformType = selectedDB.platform_type
    if (this.selectedPlatformType === 'snowflake' && this.selectedDatabase) {
      this.loadSnowflakeSchemas(this.selectedPlatform);
    }

  }

  loadSnowflakeSchemas(database: any) {
    if (!this.selectedDatabase) return;

    this.isLoadingSchemas = true;
   // const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseService.snowSchemas(database, this.selectedDatabase).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response: SnowSchema) => {
        this.schemas = response.schemas;
        this.isLoadingSchemas = false;
        if (this.schemas.length > 0) {
          this.selectedSchema = this.schemas[0];
        }
      },
      error: (error) => {
        console.log("Error loading Snowflake schemas:", error);
        this.isLoadingSchemas = false;
        this.toastService.showToast("Error loading Snowflake schemas.", { classname: 'bg-danger text-light' });
      }
    });
  }

  onSchemaChange(event: Event) {
    this.selectedSchema = (event.target as HTMLSelectElement).value;
    // console.log("Selected Schema : ", this.selectedBucket)
  }

  Codereview() {
    // Check DMSH validation first
    if (!this.isDmshValid()) {
      this.toastService.showToast("System Name is required when DMSH Storage is enabled", { classname: 'bg-danger text-light' });
      return;
    }

    if (this.rowsInput && this.rowsInput.nativeElement.value) { // Check if input exists and has a value
      const rowsInputValue = this.rowsInput.nativeElement.value;
      const parsedRows = parseInt(rowsInputValue, 10);
      if (!isNaN(parsedRows) && parsedRows > 0) {
        this.numberOfRows = parsedRows;
      } else {
        this.toastService.showToast("Please enter a valid positive number for rows", { classname: 'bg-danger text-light' })
        return;
      }
    } else {
      this.toastService.showToast("Please specify row count", { classname: 'bg-danger text-light' })
      return;
    }
    if (!this.filePath) {
      this.toastService.showToast("Filepath is not available yet, Please wait for the data to load", { classname: 'bg-warning text-light' })
      return;
    }

    const apiCodePayload: CodeGenerationRequest = {
      filepath: this.filePath,
      input_db_name: this.inputDatabaseName || '',
      output_platform_name: this.selectedPlatform || '',
      output_db_name: this.selectedDatabase || '',
      output_schema_name: this.selectedSchema || '',
      no_of_rows: this.numberOfRows,
      matillion: this.mat_box,
      dmshSystemName: this.mat_box ? this.dmshSystemName : null,
      full_data_download: this.ful_dd,

    };

    this.loadService.show();
    //const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseService.generateCode(apiCodePayload).pipe(
      finalize(() => this.loadService.hide())
    ).subscribe({
      next: (response) => {
        // console.log('Code Parameters Stored Successfully', response);
        // this.toastService.showToast("Stage 3 & 4 successfully completed", { classname: 'bg-success text-light' })
        this.dataSharing.UpdateCodeGenerationRequest(response);
        this.dataSharing.UpdateOriginalPayload(apiCodePayload);
        this.router.navigate(['/codereview']) //, { queryParams: { metadata: this.selectedDatabase, apidata: apiCodePayload } }
      },
      error: (error) => {
        console.error('Error storing Code Parameters', error)
        // this.toastService.showToast("Error saving parameters due to server Error", { classname: 'bg-danger text-light' })
      }
    })

    // this.dataSharing.UpdateCodeGenerationRequest(apiCodePayload);

  }

}

